// inspired by: https://github.com/enigma-io/boundless/blob/master/packages/boundless-typeahead/index.js
var matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;

function escapeStringRegexp(string) {
  return string.replace(matchOperatorsRegex, '\\$&');
}

export function markFuzzyMatchSubstring(text, query) {
  var fragments = text.split(new RegExp('(' + escapeStringRegexp(query) + ')', 'ig'));
  var seekValue = query.toLowerCase();
  var threshold = fragments.length;
  var i = -1;

  while (++i < threshold) {
    var fragment = fragments[i];
    fragments[i] = {
      text: fragment.replace(/ /g, "\xA0"),
      highlight: fragment.toLowerCase() === seekValue
    };
  }

  return fragments;
}
export function markStartsWithMatchSubstring(text, query) {
  var seekValue = query.toLowerCase();
  var indexStart = text.toLowerCase().indexOf(seekValue);
  var indexEnd = indexStart + seekValue.length;

  if (indexStart === -1) {
    return [{
      text: text,
      highlight: false
    }];
  }

  return [{
    text: text.slice(0, indexStart).replace(/ /g, "\xA0"),
    highlight: false
  }, {
    text: text.slice(indexStart, indexEnd).replace(/ /g, "\xA0"),
    highlight: true
  }, {
    text: text.slice(indexEnd).replace(/ /g, "\xA0"),
    highlight: false
  }];
}